<template>
  <div class="home">
    <ForgotPasswordPage :initEmail="initEmail" />
  </div>
</template>

<script>
import ForgotPasswordPage from '../components/elements/pages/ForgotPasswordPage.vue'
export default {
  name: 'ForgotPassword',
  metaInfo: {
    title: 'Forgot Password Page'
  },
  props: {
    initEmail: ''
  },
  components: {
    ForgotPasswordPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
